/** @jsxImportSource theme-ui */
import { jsx } from 'theme-ui';
import React from 'react';
import { Flex, Heading, Text } from '@theme-ui/components';
import { navigate } from 'gatsby';
import _ from 'lodash';
import { colors, typography } from '../../styles/theme';
import { Button } from '../atoms';

const style ={
  flexDirection: "column", borderRadius: "20px", p: "1.5rem", border: `1px solid ${colors.neutral200}`
}
export const CalendarSideSection = ({ slug }) => {
  return (
     <Flex sx={style}>
       <Heading as="h5" sx={{ ...typography.h5, mb: "0.5rem" }}>Compliance Calendar</Heading>
      <Text sx={{ ...typography.textMd400 }}>
        There are so many HR compliances to be taken care of
        every month, throughout the year. Check out our comprehensive calendar to stay on
        top of your game!
      </Text>
      
      <Button customStyles={{ mt: '1.5rem' }} variant="filled" onClick={() => navigate(`/wiki/${slug}-compliance-calendar`)}>
        View Calendar
      </Button>
     </Flex>
  )
}
